import React, { Component } from "react";
import { Button, Col, Modal, Row, Spin } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Socket from "../../utils/sockets";
import { startDownload } from "../../actions/DownloadAction";
import {
  ValidateAssetExtensionVideo,
  ValidateAssetExtensionAudio,
  ValidateAssetExtensionImage,
  ValidateAssetExtensionFonts,
  ValidateAssetExtensionDocuments
} from "../../utils";
import { sendNotification } from "../../utils/index";
import BunkeyAPI from "../../api/BunkeyAPI";
import fileExtension from "file-extension";
import { isModuleActive } from "../../constants/rights-constants";
import { splitDownloadList } from "../../utils/rights";
import RightsExcludedNotice from "./RightsExcludedNotice";

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0",
};

class MultiDownloadModal extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      videos: [],
      audios: [],
      fonts: [],
      documents: [],
      folders: [],
      others: [],
      loadingData: true,
      filesList: [],
      // KAN-52: lo que el backend deja fuera del original por derechos vencidos.
      excluded: [],
      loadingOptimized: false
    };
  }

  componentDidMount() {
    this.setState({
      loadingData: true
    }, () => {
      this._isMounted = true;
      this.getAllFilesFromFolderId();
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      this.setState({
        loadingData: true
      }, () => {
        this._isMounted = false;
        this.getAllFilesFromFolderId();
      });
    }
  }


  /**
   * Lista de archivos a descargar, ya resuelta por el backend
   * (dowloadMultipleTest): expande carpetas, deja fuera lo que no se entrega
   * por derechos y, en "medium", trae la ruta de la versión optimizada.
   */
  fetchFilesList = async quality => {
    const { workclient, selectedFiles, items, isTrash } = this.props;
    const elegidos = items && items.length > 0 ? items : selectedFiles;
    const resp = await BunkeyAPI({
      url: `/downloads/${workclient}/dowload/multiple`,
      method: 'POST',
      data: {
        files: elegidos.map(e => ({ name: e.name, id: e._id })),
        ...(items && items.length > 0 ? { trash: isTrash } : {}),
        quality,
        withExcluded: true
      }
    });
    return splitDownloadList(resp.data).files;
  }

  getAllFilesFromFolderId = async () => {
    const {workclient, selectedFiles, items, isTrash} = this.props;
    if (items && items.length > 0) {
      const filesBody = items.map(e => ({
        name: e.name,
        id: e._id
      }));
      console.log(filesBody);
      const resp = await BunkeyAPI({
        url: `/downloads/${workclient}/dowload/multiple`,
        method: 'POST',
        data: {
          files: filesBody,
          trash: isTrash,
          withExcluded: true
        }
      });
      const { files, excluded } = splitDownloadList(resp.data);
      this.setState({
        filesList: files,
        excluded,
        loadingData: true
      }, () => {
        this.updateFileTypesList();
      });
    } else {
      const filesBody = selectedFiles.map(e => ({
        name: e.name,
        id: e._id
      }));
      const resp = await BunkeyAPI({
        url: `/downloads/${workclient}/dowload/multiple`,
        method: 'POST',
        data: {
          files: filesBody,
          withExcluded: true
        }
      });
      if(!this._isMounted) return;
      const { files, excluded } = splitDownloadList(resp.data);
      this.setState({
        filesList: files,
        excluded,
        loadingData: true
      }, () => {
        this.updateFileTypesList();
      });
    }
  }


  updateFileTypesList = () => {
    const currentState = this.state;
    const {filesList} = currentState;
    filesList.forEach(function(file) {
      const type = file.type;
      if (type === "bunker" || type === "folder") {
        currentState.folders.push(file);
      } else if (ValidateAssetExtensionImage(file.uuid)) {
        currentState.images.push(file);
      } else if (ValidateAssetExtensionVideo(file.uuid)) {
        currentState.videos.push(file);
      } else if (ValidateAssetExtensionAudio(file.uuid)) {
        currentState.audios.push(file);
      } else if (ValidateAssetExtensionFonts(file.uuid)) {
        currentState.fonts.push(file);
      } else if (ValidateAssetExtensionDocuments(file.uuid)) {
        currentState.documents.push(file);
      } else {
        currentState.others.push(file);
      }
    });
    setTimeout(() => {
      currentState.loadingData = false;
      this.setState(currentState)
    }, 500);
  };

  // handleValidExtension = (item, listItems) => {
  //   const foundItem = listItems.find(s => s._id === item.id);
  //   if (foundItem) {
  //     const extName = fileExtension(item.name);
  //     const extOriginalUrl = fileExtension(foundItem.originalURL);
  //     if (extName) {
  //       return extOriginalUrl === extName
  //         ? item.name
  //         : item.name + "." + fileExtension(foundItem.originalURL);
  //     } else {
  //       return item.name + "." + fileExtension(foundItem.originalURL);
  //     }
  //   } else {
  //     return item.name;
  //   }
  // };

  handleValidExtension = (item) => {
    const extName = fileExtension(item.name);
    const extOriginalUrl = fileExtension(item.uuid);
    if (extName) {
      return extOriginalUrl === extName
        ? item.name
        : item.name + "." + fileExtension(item.uuid);
    } else {
      return item.name + "." + fileExtension(item.uuid);
    }
  };


  handleDownloadMultiple = async quality => {
    const { workclient, intl } = this.props;
    // La lista cargada al abrir es la del original. La optimizada se pide
    // aparte: cambian las rutas y entran los vencidos que la tienen (DES-216).
    let filesList = this.state.filesList;
    if (quality === "medium") {
      this.setState({ loadingOptimized: true });
      try {
        filesList = await this.fetchFilesList("medium");
      } catch (err) {
        this.setState({ loadingOptimized: false });
        sendNotification('error', intl, intl.formatMessage({ id: 'error_saving_download' }));
        return;
      }
      this.setState({ loadingOptimized: false });
    }
    if(filesList.length === 0){
      // KAN-52: si todo quedó fuera por derechos vencidos, decirlo; no es
      // una selección vacía.
      sendNotification('error', intl, intl.formatMessage({
        id: this.state.excluded.length > 0 ? 'download_rights_all_excluded' : 'empty-download-notification'
      }));
      return;
    }
    BunkeyAPI({
      url: `/downloads/client-multi/${workclient}`,
      method: "POST",
      data: {
        data: filesList.map(e => e.id),
        status: "success"
      }
    });
    const dataToDownloadClean = filesList.map(e => ({
      uuid: e.uuid,
      // name: selectedFiles.find(s => s._id === e.id) ? selectedFiles.find(s => s._id === e.id).originalURL : e.name
      name: this.handleValidExtension(e)
    }));
    const uuid = Socket.getInstance().id;
    this.props.startDownload({
      id: uuid,
      uuid: uuid,
      name: "compressed",
      state: "download_in_progress",
      client: !workclient ? uuid : workclient,
      quality
    });
    Socket.getInstance().emit("download_gpt_listener_from_lambda", {
      id: uuid,
      env: process.env.REACT_APP_BUNKEY_ENV
        ? process.env.REACT_APP_BUNKEY_ENV
        : "qa",
      files: dataToDownloadClean
    });
    this.props.handleHiddenModal();
  };

  /**
   * DES-216 / KAN-52 — La descarga múltiple deja fuera los archivos con
   * derechos vencidos (lo filtra el backend en dowloadMultipleTest). Sin este
   * aviso desaparecían en silencio y quien descarga no sabía por qué le
   * faltaban. Desde KAN-52 la lista la da el backend, con nombre y ruta, e
   * incluye lo que va dentro de las carpetas; y se avisa también con el
   * módulo. Sin el módulo, el texto aclara que en la optimizada sí entran.
   */
  renderAvisoVencidos() {
    const { modules, intl } = this.props;
    if (this.state.loadingData) return null;
    return (
      <RightsExcludedNotice
        intl={intl}
        excluded={this.state.excluded}
        messageId={
          isModuleActive(modules, "useRights")
            ? "download_rights_excluded"
            : "multi_download_rights_excluded"
        }
      />
    );
  }

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      newColor,
      handleMultiDownload,
      modules
    } = this.props;
    // La papelera trae su propio handleMultiDownload: ahí no se ofrece.
    const ofreceOptimizada =
      !handleMultiDownload && !isModuleActive(modules, "useRights");

    const {
      images,
      videos,
      audios,
      fonts,
      documents,
      folders,
      others,
      loadingData,
      filesList
    } = this.state;

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="download-modal-asset"
      >
        <div className="download-modal-asset-title">
          {intl.formatMessage({ id: "multi-download-title" })}
        </div>
        <div
          style={{
            color: "#6F6F6F",
            fontSize: 18,
            fontWeight: 400,
            marginBottom: 36
          }}
        >
          {intl.formatMessage({ id: "multi-download-subtitle" })}
        </div>

        {this.renderAvisoVencidos()}

        {!loadingData && <div
          style={{
            margin: "0 auto",
            width: "70%",
            marginBottom: 50,
            fontSize: 15,
            fontWeight: 700
          }}
        >
          {filesList.length === 0 && <div
            style = {{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: 100,
            }}
          >
            <p style = {{
              fontSize: 15,
              fontWeight: 700,
              margin: 0,
              color: "#6F6F6F",
            }}>
              {intl.formatMessage({
                id: this.state.excluded.length > 0 ? "download_rights_all_excluded" : "empty-download-text"
              })}
            </p>
          </div>}
          {images.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#3D85FD" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-images" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {images.length}
              </Col>
            </Row>
          )}
          {videos.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#FFB44F" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-videos" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {videos.length}
              </Col>
            </Row>
          )}
          {audios.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#FFB44F" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-audios" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {audios.length}
              </Col>
            </Row>
          )}
          {fonts.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#FFB44F" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-fonts" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {fonts.length}
              </Col>
            </Row>
          )}
          {documents.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#3AA52B" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-docs" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {documents.length}
              </Col>
            </Row>
          )}
          {folders.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#3AA52B" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-folders" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {folders.length}
              </Col>
            </Row>
          )}
          {others.length > 0 && (
            <Row
              type={"flex"}
              justify={"center"}
              align={"middle"}
              style={{
                color: "#6F6F6F",
                borderBottom: "0.25px solid #cccccc",
                padding: "6px 0"
              }}
            >
              <Col span={3}>
                <div
                  style={{ width: 15, height: 15, background: "#3AA52B" }}
                ></div>
              </Col>
              <Col span={15}>
                {intl.formatMessage({ id: "multi-download-others" })}
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {others.length}
              </Col>
            </Row>
          )}
        </div>}
        
        {loadingData && <div style={{ margin: '0 auto', width: '70%', marginBottom: 50, fontSize: 15, fontWeight: 700, }}>
          <div style={spinnerStyle}>
            <Spin spinning={true} />
          </div>
        </div>}

        <Row type={"flex"} justify={"center"} className="download-buttons">
          {/* DES-216: sin el módulo de derechos también se puede bajar la
              versión optimizada, como en la vista de un archivo. Va aparte
              de filesList: si todo lo elegido está vencido la lista del
              original queda vacía, pero la optimizada puede no estarlo. */}
          { filesList.length !== 0 && <Button
              type="default"
              disabled={loadingData}
              style={{
                width: "100%"
              }}
              onClick={() => {
                if (handleMultiDownload) {
                  handleMultiDownload();
                  return;
                }
                this.handleDownloadMultiple("original");
              }}
            >
              {ofreceOptimizada ? "Original" : intl.formatMessage({ id: "download_asset" })}
            </Button>
          }
          {ofreceOptimizada && !loadingData && (
            <Button
              type="default"
              style={{ width: "100%" }}
              loading={this.state.loadingOptimized}
              onClick={() => this.handleDownloadMultiple("medium")}
            >
              {intl.formatMessage({ id: "optimized_version" })}
            </Button>
          )}
          <Button
            style={{ color: newColor, borderColor: newColor, width: '100%' }}
            onClick={() => this.props.handleHiddenModal()}>{intl.formatMessage({ id: "cancel_button" })}</Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFiles: state.selectedFiles.data,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    workclient: state.client.workclient,
    // Para avisar qué queda fuera por derechos vencidos (DES-216).
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  startDownload
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiDownloadModal))
);
